export default __webpack_public_path__ + "static/media/gallery_00.69a6eee2.jpg";